export enum NewsPostType {
  URL = 0,
  VIDEO = 1,
  AUDIO = 2,
  IMAGE = 3,
  TEXT = 4,
  LIVE = 6
}

export enum PostType {
  URL = 0,
  VIDEO = 1,
  AUDIO = 2,
  IMAGE = 3,
  TEXT = 4,
  DOCUMENT = 6,
  MEDIA = 7
}

export enum PostStatus {
  ACTIVE = 'ACTIVE',
  DELETED_QUALITY_QUEUE = 'DELETED_QUALITY_QUEUE',
  DELETED_REPORT_QUEUE = 'DELETED_REPORT_QUEUE',
  USER_BANNED_QUALITY_QUEUE = 'USER_BANNED_QUALITY_QUEUE',
  USER_BANNED_REPORT_QUEUE = 'USER_BANNED_REPORT_QUEUE',
  PROCESSING = 'PROCESSING',
  PROCESSED_WITH_ERROR = 'PROCESSED_WITH_ERROR',
  SUSPENDED_REPORTED_USER = 'SUSPENDED_REPORTED_USER',
  DELETED = 'DELETED',
  DELETED_BY_DEVELOPMENT = 'DELETED_BY_DEVELOPMENT',
  PROCESSED_WAITING_UPLOAD = 'PROCESSED_WAITING_UPLOAD',
  EXPIRED = 'EXPIRED',
  DELETED_BY_SYSTEM = 'DELETED_BY_SYSTEM',
  DELETED_BY_BACKOFFICE = 'DELETED_BY_BACKOFFICE',
  DELETED_DUE_BANISHMENT = 'DELETED_DUE_BANISHMENT',
  DELETED_BY_RISK_ANALYSIS = 'DELETED_BY_RISK_ANALYSIS',
  SCHEDULED = 'SCHEDULED',
  DELETED_BY_RISK_SPAM_ML_ANALYSIS = 'DELETED_BY_RISK_SPAM_ML_ANALYSIS',
  DELETED_BY_RISK_NSFW_ANALYSIS = 'DELETED_BY_RISK_NSFW_ANALYSIS',
  AWAITING_MODERATION = 'AWAITING_MODERATION',
  DISAPPROVED = 'DISAPPROVED',
  HIDDEN_AS_SPAM = 'HIDDEN_AS_SPAM'
}
